import { APIInjection } from '..';
import { axiosInstance } from '../../../services/apiInterceptor';

export type ColumnMappedData = {
  field: string;
  data: { label: string; value: string }[];
};

export async function fetchAndMapApiData(
  apiInjection: APIInjection[],
  token: string
): Promise<ColumnMappedData[]> {
  try {
    const fetchedData = await Promise.all(
      apiInjection.map(async (api) => {
        const response = await axiosInstance.get(
          `${process.env.REACT_APP_WEALTHLANE_API_ENDPOINT}/${api.url}`,
          {
            headers: {
              Authorization: `Bearer ${token}`,
            },
          }
        );

        const result = response.data;
        return {
          field: api.injectDataToField,
          data: result.map((item: Record<string, any>) => ({
            label: item[api.mapper.label],
            value: item[api.mapper.value],
          })),
        };
      })
    );
    return fetchedData;
  } catch (error) {
    throw new Error('Failed to fetch API data: ' + (error as Error).message);
  }
}
